var map = {
	"./Colegio_mayor_coar_logo.png": 9214,
	"./Essalud_Hz.png": 443,
	"./La_Panera.png": 3362,
	"./Lincuna.png": 2829,
	"./contonga.png": 8388,
	"./logo_sanpablo_huaraz.png": 8053
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 839;